define('modules/page_listing/views/copy_integrations_popup',['require','exports','module','common/views/modal_view','ldsh!../templates/copy_integrations_popup'],function(require, exports, module) {
  "use strict";

  var ModalView = require("common/views/modal_view");

  module.exports = ModalView.extend({
    template: require("ldsh!../templates/copy_integrations_popup"),
    triggers: {
      "click .js-ok": "ok",
      "click .js-cancel": "cancel"
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

  _.extend(module.exports, {
    show: function(page) {
      var popup = new module.exports({model: page}),
          defer = $.Deferred();
      popup.on("ok", _.bind(defer.resolve, defer));
      popup.on("cancel", _.bind(defer.reject, defer));
      defer.always(_.bind(popup.hide, popup));
      return defer.promise();
    }
  });
});


